import React from "react";
import { SessionCookieContextType } from "./SessionCookieContext.types";

const SessionCookieContext = React.createContext<SessionCookieContextType | undefined>(undefined);

export default SessionCookieContext;
